import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-preload-list',
  templateUrl: './preload-list.component.html',
  styleUrls: ['./preload-list.component.css'],
})
export class PreloadListComponent extends BaseListCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    var _self = this;
    _self.locator.config
      .getProperty('endpoint.preloadlistdata')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.code = data.code;
    form.status = data.status;
    form.access = data.access;
    form.parentList = data.parentList;
  }

  savePreloadList(id: any) {
    this.get(id);
    this.preload();
  }
}
